import LeftCreditTable from "./LeftCreditTable";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx"

const LeftCredit = ({
    handleRangeType,
    creditLeft,
    showDatepicker,
    startDate, endDate,
    setStartDate,
    setEndDate,
    selectedCustomer,
    rangeType,
    rangeLoading,
    rangeError
}) => {
    const creditTableHeader = ["Total Credit", "Amount Paid", "Amount Left", "Guest", "Address", "Email", "ID", "Phone"];

    const hasData = creditLeft.length > 0;

    const handleExportExcel = () => {
        const worksheetData = []
        const header = creditTableHeader

        // Meta info
        worksheetData.push(["Customer", selectedCustomer || "All"])

        if (rangeType !== "All") {
            worksheetData.push(["Start Date", startDate])
            worksheetData.push(["End Date", endDate])
        }

        worksheetData.push([])

        // Table header
        worksheetData.push(header)

        // Table rows
        creditLeft.forEach((info) => {
            worksheetData.push([
                info.TotalCredit,
                info.AmountPaid,
                info.amountleft,
                info.guest,
                info.guestAddress,
                info.guestEmail,
                info.guestID,
                info.guestPhone
            ])
        })

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)

        /* -------------------------------
           Column width = padding effect
        -------------------------------- */
        worksheet["!cols"] = [
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 30 },
            { wch: 25 },
            { wch: 30 },
            { wch: 15 },
            { wch: 18 }
        ]

        /* -------------------------------
           Bold header row
        -------------------------------- */
        const headerRowIndex =
            rangeType === "All" ? 4 : 6 // dynamic row index

        header.forEach((_, colIndex) => {
            const cellRef = XLSX.utils.encode_cell({
                r: headerRowIndex,
                c: colIndex
            })

            if (worksheet[cellRef]) {
                worksheet[cellRef].s = {
                    font: { bold: true }
                }
            }
        })

        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, "Credit Left")

        /* -------------------------------
           File name with customer
        -------------------------------- */
        const customerName = selectedCustomer.replace(/\s+/g, "_")

        XLSX.writeFile(
            workbook,
            `credit-${customerName}-${rangeType}.xlsx`
        )
    }

    return (
        <div className='left-credit'>
            <div>
                <div className="px-[3rem] mb-4">
                    <div className='flex justify-between'>
                        <select
                            onChange={handleRangeType}
                            className="
                            p-2
                            rounded-xl
                            text-sm
                            outline-none
                            transition-all duration-200

                            hover:bg-white/15
                            cursor-pointer
                        "
                        >
                            <option value="" disabled selected className="text-gray-400">
                                Please select an option
                            </option>
                            <option value="All" className="text-black">
                                All
                            </option>
                            <option value="Ranged" className="text-black">
                                Range
                            </option>
                        </select>

                        <button
                            onClick={handleExportExcel}
                            disabled={!hasData}
                            className="
                                px-4 py-2
                                rounded-md
                                bg-green-600
                                text-white
                                text-sm
                                font-medium
                                hover:bg-green-700
                                disabled:opacity-50
                                disabled:cursor-not-allowed
                                transition
                            "
                        >
                            Export to Excel
                        </button>

                    </div>


                    {showDatepicker &&
                        <div className='flex py-2 z-50 relative'>
                            <div>
                                <label>Start:</label>
                                <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />
                            </div>
                            <div>
                                <label>End:</label>
                                <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} />
                            </div>
                        </div>}
                </div>
            </div>

            <LeftCreditTable
                header={creditTableHeader}
                creditLeft={creditLeft}
                hasData={hasData}
                loading={rangeLoading}
                error={rangeError}
            />
        </div>
    )
}

export default LeftCredit